var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.queryResult)?_c(((_vm.variable.filterType) + "_filter"),{ref:"filter",tag:"component",attrs:{"queryResult":_vm.queryResult,"variable":_vm.variable}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }